import { theme } from "@src/theme";
import React from "react";

interface ArticleSVGProps {
  $size: number;
  $active?: boolean;
}

const ArticleSVG: React.FC<ArticleSVGProps> = ({ $size, $active }) => {
  const strokeColor = $active ? theme.colors.yellow : "black";
  const fillColor = $active ? theme.colors.yellow : "black";

  return (
    <svg
      width={$size}
      height={$size}
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83093 2.40625H1.25C0.973858 2.40625 0.75 2.63011 0.75 2.90625V18.5512C0.75 18.8273 0.973858 19.0512 1.25 19.0512H13.3888C13.6649 19.0512 13.8888 18.8273 13.8888 18.5512V6.55689"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="3.35"
        y1="4.68125"
        x2="7.13657"
        y2="4.68125"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="3.35"
        y1="7.52891"
        x2="5.16001"
        y2="7.52891"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="3.35"
        y1="12.3531"
        x2="11.1366"
        y2="12.3531"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="3.35"
        y1="16.3922"
        x2="11.1366"
        y2="16.3922"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="3.35"
        y1="14.3375"
        x2="11.1366"
        y2="14.3375"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M15.4887 0.550008L15.818 0.879323C16.2718 1.33367 16.2031 2.13909 15.6634 2.67827L8.87222 9.46942L6.67195 10.2743C6.39566 10.3759 6.12663 10.2441 6.07193 9.98125C6.0535 9.88588 6.0622 9.78726 6.09704 9.69659L6.91754 7.47734L13.6897 0.704619C14.2294 0.165435 15.0349 0.0956652 15.4887 0.550008Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth="0.5"
      />
    </svg>
  );
};

export default ArticleSVG;
